import { useState } from "react";
import { reasons, faqs } from "@/mocks/freegua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-12 lg:grid-cols-5">
          {/* 左侧：为什么零元 */}
          <div className="lg:col-span-2">
            <span className="font-label text-sm font-bold tracking-widest text-accent-600">为什么能免费吃瓜</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              真正不花钱、不注册，凭什么是它
            </h2>
            <p className="mt-4 max-w-md text-base leading-relaxed text-foreground-600">
              素材免费吃瓜、零元直接看，是因为我们只做整理、不做门槛。你看到的每一则，都只是把散落的片段按顺序摆好。
            </p>

            <div className="mt-8 space-y-4">
              {reasons.map((r) => (
                <div key={r.title} className="flex items-start gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className={`${r.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-base font-extrabold text-foreground-950">{r.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧：FAQ */}
          <div className="lg:col-span-3">
            <h3 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">围观前，先替你把问题说清</h3>
            <div className="mt-6 divide-y divide-background-200 rounded-2xl border border-background-200/80 bg-background-50">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      aria-expanded={open}
                      className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-5 text-left md:px-6"
                    >
                      <span className="flex items-center gap-3 text-base font-bold text-foreground-900">
                        <span className="whitespace-nowrap font-label text-sm font-black text-primary-600">
                          Q{i + 1}
                        </span>
                        {f.q}
                      </span>
                      <i
                        className={`${open ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-xl text-accent-600`}
                        aria-hidden="true"
                      />
                    </button>
                    {open && (
                      <div className="px-5 pb-5 pl-14 md:px-6 md:pl-16">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}